class QuickAddButtonWidth {
  constructor() {
    this.initButtons();

    // Reinitialize on window resize
    this.resizeTimeout = null;
    window.addEventListener("resize", () => {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => this.initButtons(), 150);
    });

    // Listen for dynamic content updates (e.g., filtering, pagination)
    this.observeNewButtons();
  }

  initButtons() {
    const buttons = document.querySelectorAll(
      ".quick-add--full-width-on-hover .quick-add__submit:not([data-width-initialized])"
    );

    buttons.forEach((button) => {
      // Skip if button is not visible
      if (button.offsetParent === null) return;

      // Remove inline width first to get natural width
      button.style.width = "";

      // Force a reflow to get the actual computed width
      const naturalWidth = button.offsetWidth;

      // Only set width if we got a valid measurement
      if (naturalWidth > 0) {
        button.style.width = `${naturalWidth}px`;
        button.dataset.naturalWidth = naturalWidth;
        button.dataset.widthInitialized = "true";
      }
    });
  }

  observeNewButtons() {
    // Observe the document for new buttons being added
    const observer = new MutationObserver((mutations) => {
      const hasNewButtons = mutations.some((mutation) => {
        return Array.from(mutation.addedNodes).some((node) => {
          if (node.nodeType === 1) {
            // Element node
            return (
              node.querySelector?.(
                ".quick-add--full-width-on-hover .quick-add__submit"
              ) || node.classList?.contains("quick-add__submit")
            );
          }
          return false;
        });
      });

      if (hasNewButtons) {
        // Small delay to ensure layout is ready
        setTimeout(() => this.initButtons(), 50);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    new QuickAddButtonWidth();
  });
} else {
  new QuickAddButtonWidth();
}
